<template>
  <div class="flex-column">
    <b-button
      :id="name"
      v-b-tooltip.hover="$store.getters['app/isLargeScreen']?$t(toolTipText):''"
      v-ripple.400="'rgba(225,225,225,0.15)'"
      :variant="variant"
      :disabled="disabled || loading"
      :class="btnClass"
      @click="upload"
    >
      <slot>
        <div v-if="loading">
          <b-spinner
            small
            type="grow"
            class="mr-1"
          />
          <span>{{ $t(loadingText) }}</span>
        </div>
        <div v-else>
          <feather-icon
            :icon="icon"
            style="margin-right: 4px"
          />
          <span
            v-if="!iconOnly"
            class="align-middle"
          >{{ $t(label) }}</span>
          <span> <b
            v-if="isRequired"
            class="text-danger"
            style="font-size: 15px"
          > *</b>
          </span>
        </div>
      </slot>
    </b-button>
    <div
      v-if="previewFiles.length"
      class="row mb-1"
    >
      <div
        v-for="(file,i) in previewFiles"
        :key="i"
        class="col-12 mt-1"
      >
        <div
          class="d-flex align-items-center"
        >
          <b-avatar
            size="30"
            variant="light-primary"
          >
            <FeatherIcon :icon="fileIcon" />
          </b-avatar>
          <div style="margin-right: 5px;" />
          <div class="col-12">
            <div class="row align-items-center">
              <div :class="hideRemove || hidePreview?'col-md-8':'col-md-6'">
                <!--                  <b-badge variant="light-primary">-->
                <div style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;width: 200px !important;">
                  <b> {{ file.name }}</b>
                </div>
                <!--                    </b-badge>-->
              </div>
              <div
                v-if="file.path && !hidePreview"
                :class="hideRemove?'col-md-4':'col-md-3'"
              >
                <sikanii-button
                  icon-only
                  variant="flat-primary"
                  icon="DownloadCloudIcon"
                  @click="preview(file)"
                />
              </div>
              <div
                v-if="!hideRemove"
                :class="hidePreview?'col-md-4':'col-md-3'"
              >
                <sikanii-button
                  icon-only
                  variant="flat-danger"
                  icon="XIcon"
                  @click="removeFile(i)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SikaniiButton from '@/layouts/components/SikaniiButton.vue'
import {
  BAvatar, BButton, BSpinner, VBTooltip, VBHover,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import downloadFile from '@/libs/mixins/downloadFile'

export default {
  name: 'SikaniiFileButton',
  components: {
    SikaniiButton,
    BAvatar,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
    'b-hover': VBHover,
  },
  mixins: [downloadFile],
  props: {
    btnClass: { type: String, default: '' },
    loadingText: { type: String, default: 'Loading...' },
    icon: {
      type: String,
      default: 'UploadCloudIcon',
    },
    fileIcon: {
      type: String,
      default: 'FileIcon',
    },
    rules: {
      type: String,
      default: '',
    },
    showErrors: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Upload',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    previewFiles: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
    hideRemove: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    variant: {
      type: String,
      default: 'primary',
    },
    accept: {
      type: String,
      default: 'image/jpeg, image/png, image/jpg, application/pdf',
    },
    toolTipText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      uploadedFiles: [],
      touched: false,
    }
  },
  computed: {
    isRequired() {
      return this.rules.includes('required')
    },
  },
  methods: {
    preview(file) {
      this.downloadFile(file.path, file.name)
    },
    formatName(name) {
      return name.replaceAll('_', ' ')
    },
    removeFile(i) {
      this.$emit('onFileRemoved', i)
    },
    upload() {
      const el = document.createElement('input')
      el.type = 'file'
      if (this.multiple) {
        el.multiple = true
      }
      el.accept = this.accept
      el.onchange = event => {
        const { files } = event.target
        if (this.multiple) {
          this.uploadedFiles = [...this.uploadedFiles, ...files]
          this.$emit('onFileUpload', this.uploadedFiles)
        } else {
          const reader = new FileReader()
          reader.readAsDataURL(files[0])
          reader.onload = () => {
            const data = {
              file: files[0],
              dataUrl: reader.result,
            }
            this.$emit('onFileUpload', data)
          }
        }
      }
      el.click()
    },
  },
}
</script>
<style scoped>

</style>
